import { validateEmail } from "./validateEmail";

// Validate input submissions for updating user details in customer page
export const validateUserDetails = (fName, lName, email, phone) => {
  let error = false;
  if (!fName || fName.length === 0) {
    alert("First name is required");
    error = true;
  }
  if (!lName || lName.length === 0) {
    alert("Last name is required");
    error = true;
  }
  if (!email || email.length === 0 || !validateEmail(email)) {
    alert("Valid email is required");
    error = true;
  }
  if (phone.length !== 10 || isNaN(phone)) {
    alert("Valid phone number is required i.e: xxxxxxxxxx");
    error = true;
  }
  return error;
};

// Validate input submissions for updating user payment details in customer page
export const validatePaymentDetails = (city, state, address, zip) => {
  let error = false;
  if (!city || city.length === 0) {
    alert("City is required");
    error = true;
  }
  if (!state || state.length === 0) {
    alert("State is required");
    error = true;
  }
  if (!address || address.length === 0) {
    alert("Address is required");
    error = true;
  }
  if (!zip || zip.length === 0) {
    alert("Zipcode is required");
    error = true;
  }
  return error;
};